// 全局消息提示配置文件
let msgCfg = {
};

// 登录模块
msgCfg.login = {
    userName: '请输入用户名',
    mobile: '请输入手机号',
    password: '请输入密码',
    login_success: '登录成功！',
    login_error: '登录失败,请检查该用户是否注册！',
    login_err: '登录失败,密码错误！',
    checkPwd: '两次输入的密码不一致'
};

//充电桩模块
msgCfg.pile = {
    List: {
        searchTxt: '请输入充电桩型号查询'
    },
    Detail: {
        pileTypeName: '请输入名称',
        pileTypeCode: '请输入型号',
        powerIn: '请输入额定电压',
        chargingSpeed: '请输入充电速度'
    },
    basicMsg:'管理系统内所有充电桩产品的基本信息',
    ratedVoltage:'主要包括输入电源的电压峰谷值和频率等',
    ratedCurrent:'主要包括输出电源的电压峰谷值和频率等',
    stabilizationAccuracy:'主要包括输出电能的稳定精度'
}
//充电站管理
msgCfg.pileStation={
    List:{
        searchTxt: '请输入充电站名称查询'
    },
    Detail:{
        county:"请选择省市区名称",
        stationName:"请输入充电站名称",
        stationAbbr:'请输入充电站简称',
        stationAddr:"请输入充电站地址",
        stationStatus:"请选择充电站状态",
        portType:'请选择停车场状态',
        operDate:"请选择投运时间",
        chargeAmt:"请输入充电费用",
        parkNum:'请输入车位数量',
        stationOpenTime:"请选择运营开始时间",
        stationCloseTime:'请选择运营结束时间',
        stationType:'请选择充电站类型',
        tel:"请输入联系人电话",
        imrfc2397:'请上传图片',
        contactsName:"请输入联系人姓名",
    }
}
//客户反馈
msgCfg.feedback = {
    List: {
        searchTxt: '请输入客户名称查询'
    },
}

//客户推送消息
msgCfg.custpushmsg = {
    List: {
        searchTxt: '请输入客户手机号查询',
    },
    Detail: {
        msgTitle: '请输入标题',
        msgType: '请输入类型'
    }
}
//二维码管理
msgCfg.event = {
    List:{
        searchTxt:"请输入编号查询"
    },
    Detail:{
        eventNo:'请输入活动编号',
        eventNoReg:"活动编号只能是大小写字母和数字的组合",
        eventName:"请输入活动名称",
        eventType:"请选择活动类型",
        eventOrg:"请输入组织方",
        eventBegin:"请选择活动开始时间",
        eventEnd:"请选择活动结束时间",
        eventTime:"活动结束时间不能早于活动开始时间"
    }
},
//景点管理
msgCfg.travelPlace = {
    List: {
        searchTxt: '请输入景点名称查询'
    },
    Detail: {
        placeCounty: '请输入省市区名称',
        placeName: '请输入景点名称',
        placeAddr: '请输入详细地址',
        placeStatus: '请输入景点状态',
        placeLon: '请输入经度',
        placeLat: '请输入纬度',
        placeOpenTime: '请输入运营开始时间',
        placeCloseTime: '请输入运营结束时间',
        placeType: '请输入景点类型',
        placeScore: '请输入景点评分',
        placePrice: '请输入景点价格',
        parkNum: '请输入车位数量',
        pileNum: '请输入充电桩数量',
        placeRemark: '请输入备注',
    },
}

//OTA通讯记录
msgCfg.pileotarecord = {
    List: {
        searchTxt: '请输入设备码或序列号（短号）查询'
    },
}

//OTA通讯协议解析
msgCfg.pilehistory = {
    List: {
        searchTxt: '请输入设备码或序列号（短号）查询'
    },
}

//OTA通讯协议解析
msgCfg.custsms = {
    List: {
        searchTxt: '请输入手机号查询'
    },
}

//系统通知模块
msgCfg.alert = {
    List:{
        searchTxt:'请输入通知类型名称查询'
    },
    Detail:{
        corpNo:'请选择公司名称',
        alertType:'请选择通知类型',
        alertMethod:'请选择通知方式',
        alertMail:'请输入邮件通知人',
        alertSms:'请输入短信通知人'
    }
};
//充电桩管理模块
msgCfg.pileManage = {
    List:{
        searchTxt: '请输入充电桩编码查询'
    },
    Detail:{
        serialNo:'请输入充电桩序列号',
        corpNo: '请输入充电桩所在的单位',
        pileCode: '请输入充电桩编码',
        pileTypeNo: '请选择充电桩产品型号',
        pileNo:'请选择充电桩编号',
        rcsNo: '请选择RCS设备',
        instType: '请选择安装方式',
        optType: '请选择运营方式',
        cardNo: '请输入物联卡号',
        //检验充电桩编号
        checkPileCode:'请输入6-12位的数字,字母,大写字母的组合',
        //检验物联卡号
        checkCardNo:'请输入6-12位的数字,字母,大写字母的组合',
        softVersion: '请输入充电桩程序版本',
        productDate: '请选择出厂日期',
        //检验出厂日期
        checkProductDate:'出厂日期不能晚于今天',
        //检验安装日期
        checkInstDate:'安装日期不能早于出厂日期',
        instDate:'请选择安装日期',
        elecType: '请选择供电方式',
        subsidyFlg:'请选择是否享受补贴',
    }
};
//RCS型号管理模块
msgCfg.rcstype = {
    List:{
        searchTxt : '请输入RCS型号编号或RCS名称查询'
    },
    Detail:{
        rcsTypeName:'请输入rcs名称',
        rcsTypeCode:'请输入rcs型号',
        rcsPowerIn:'请输入rcs电源参数',
        networkCode:'请选择网络制式',
        encryptionType:'请选择加密方式',
        interfaceChargingPole:'请选择与充电桩接口',
        interopType:'请选择电能采集交互方式',
        rcsLength:'请输入安装长度',
        rcsWidth:'请输入安装宽度',
        rcsHeight:'请输入安装高度',
        needTiming:'请选择是否需要服务器授时',
        sdCapacity:'请输入本地存储容量',
    }
};
//车队管理
msgCfg.autoTeam = {
    List:{
        searchTxt:'请输入车队名称查询'
    },
    Detail:{
        teamName:'请输入车队名称',
        contractName:"请输入车队联系人姓名",
        contractPhone:'请输入车队联系人号码'
    }
};
msgCfg.autoMatain = {
    List:{
        searchTxt:"请输入车牌号查询"
    },
    Detail:{
        matainDate:'请选择维修日期',
        matainType:'请选择维修状态',
        matainRemark:'请输入维修评论',
        matainAmt:"请输入维修金额",
        matainFactory:'请输入维修厂家'
    }
}
//RCS设备管理
msgCfg.rcs ={
    List:{
        searchTxt:'请输入RCS编号查询'
    },
    Detail:{
        serialNo:'请输入RCS序列号',
        corpNo:'请选择RCS所在的公司',
        rcsNo:'请输入RCS编码',
        rcsTypeNo:'请选择RCS产品型号',
        rcsCode:'请输入RCS编号',
        rcsLon:'请输入经度',
        checkLon:'请输入正确的经度范围',
        rcsLat:'请输入纬度',
        checkLat:"请输入正确的纬度范围",
        simNo:"请输入SIM卡号"
    }

}
//运维人员管理模块
msgCfg.operation = {
    List:{
        searchTxt:'请输入手机号或姓名查询'
    },
    Detail:{
        mobile:'请输入手机号',
        employName:'请输入姓名',
        optStatus:'请选择账号状态',
        optType:'请选择运维类型',
        certNo:'请输入身份证号码',
        driveNo:'请输入驾照副页档案编号',
        driveMode:'请选择准驾车型',
        groupProCity:'请选择省市',
        changeRental:'请选择负责网点'
    },
    ResetPwd:{
        password:'请输入密码',
        passwordNew:'请再次输入密码'
    }
};
//运维管理-兑换卡
msgCfg.cashcard = {
    List:{
        searchTxt:'请输入兑换码、兑换账号'
    },
}


//预约订单管理模块
msgCfg.book = {
    List:{
        searchTxt:'请输入车牌号查询'
    }
};
msgCfg.autoWarn_list = {
    List:{
        searchTxt:'请输入车牌号'
    }
}
//操作日志模块
msgCfg.actionlog = {
    List:{
        searchTxt:'请输入操作人员查询'
    }
};

//消息群推模块
msgCfg.pushmessage = {
    List:{
        searchTxt:'请输入通知标题查询'
    },
    ListPush:{
        messageType:'请选择消息类型',
        messageTitle:'请输入通知标题',
        messageContent:'请输入通知内容'
    },
    SinglePush:{
        searchTxt:'请输入用户姓名'
    }
}

// user模块-List
msgCfg.user = {
    List: {
        searchTxt: '请输入手机号查询'
    },
    Detail: {
        mobile: '请输入手机号',
        roleId: '请选择角色',
        dataCheck: '请选择数据校验',
        corpNo: '请选择公司名称'
    },
    ResetPwd:{
        password:'请输入密码',
        passwordNew:'请再次输入密码',
    },
};

// 角色模块
msgCfg.role = {
    List: {
        initErr: '初始化角色列表失败，请稍后重试！',
        searchTxt: '请输入角色名称查询'
    },
    Detail: {
        roleName: '请输入角色名称',
        menu: '请选择菜单'
    }
};

// 设备管理
msgCfg.terminal = {
    List: {
        searchTxt: '请输入ICCID号查询',
        searchICCID: '请输入ICCID号查询'
    },
    Detail: {
        tmnlIccid: '请输入ICCID号',
        corpCode: '请选择管理单位',
        tmnlName: '请输入终端名称',
        tmnlClass: '请选择终端分类',
        tmnlType: '请选择终端类型',
        modelCode: '请输入终端型号',
        tmnlStatus: '请选择终端状态',
        manufacturer: '请输入终端厂家',
        hdVersion: '请输入TBOX硬件版本号',
        softVersion: '请输入TBOX软件版本号',
        productionDate: '请选择生产日期',
        docCreateDate: '请选择安装日期',
        tmnlParam: '请选择终端参数'
    },
    proDate: '生产日期',
    docDate: '安装日期'
};

// 站点管理
msgCfg.rental = {
    List: {
        searchTxt: '请输入站点名称查询'
    },
    Detail: {
        rtProCity: '请选择省市区县',
        rtName: '请输入站点名称',
        rtOrg: '请输入站点单位',
        rtAddr: '请输入站点地址',
        serMode: '请选择服务范畴',
        rtTel: '请输入服务电话',
        operDate: '请选择投运日期',
        rtDate: '请选择租约到期日',
        parkNum: '请输入车位数量',
        pileNum: '请输入充电桩数量',
        rtLon: '请输入经度',
        rtLat: '请输入纬度',
        rtStatus: '请选择租赁状态',
        rtRemark: '位置描述...',
        rentalCenter: '请选择中心坐标点',
        corrRentalCenter: '坐标格式错误',
        appRange: '请选择APP显示的还车范围',
        rtRange: '请选择实际的还车范围',
        electricFenceStatus: '请选择电子围栏的创建状态',
        reTelok:'请输入正确的电话格式',
    }
};
// 围栏管理
msgCfg.fence = {
    List: {
        searchTxt: '请输入围栏名称查询'
    },
    Detail: {
        fenceName: '请输入围栏名称',
        fenceStatus: '请选择围栏状态',
        warnType: '请选择围栏报警类型',
        warnVal: '请输入围栏报警阈值(秒)',
        fenceType: '请选择围栏类型',
        fenceRadius: '请绘制圆形围栏',
    }
};
// 日志
msgCfg.ota = {
    List: {
        searchTxt: '请输入站点名称查询',
        subtitle: 'OTA消息列表'
    }
};

//命令日志
msgCfg.otaCommand = {
    List:{
        searchTxt:'请输入设备码查询'
    }
}

// 登入日志
msgCfg.loginlog = {
    List: {
        searchTxt: '请输入登录账号查询',
    }
};


// 公司管理
msgCfg.corp = {
    List: {
        searchTxt: '请输入公司名称查询'
    },
    Detail: {
        mobile: '请输入手机号',
        corpType: '请选择公司类型',
        dataCheck: '请选择数据校验',
        corpNo: '请选择公司名称',
        ownerDisc: '请输入地址',
        code: '003',
        corpName: '请输入运营商名称',
        contrct: '请输入联系人',
        contactPhone: '请输入联系人手机号',
        ownerDisc: '请输入地址',
        sysId: '请输入唯一APP ID',
        sendTmnlMsg: '请选择是否推送设备信息',
        sendWarnMsg: '请选择是否推送警告信息',
    }
};
//组织机构
msgCfg.org = {
    Detail:{
        id:'请输入机构名称',
        orgName:'请选择所属机构',
    }

};
// 发票管理
msgCfg.custInvoice = {
    List: {
        searchTxt: '请输入收件人姓名或手机号'
    },
    Detail: {
        invTypeCode: '发票类型',
        deliveryNo:'请输入邮寄单号',
        deliveryDate: '邮寄日期',
        deliveryType: '请选择邮寄方式',
        invTitle: '发票抬头',
        receiverAddr: '收件人地址',
        receiverMobile: '收件人电话',
        receiver: '收件人名称',
        listId: '流水编号',
        remark: '备注',
        invContent: '发票内容',
        taxNo: '纳税人识别号',
        invStatus:'开票状态'
    }
};

// app版本控制
msgCfg.app = {
    List: {
        searchTxt: '请输入版本号查询'
    },
    Detail: {
        corpNo:'请选择公司',
        versionNo:'请输入版本号',
        versionDesc:'请输入版本描述',
        versionUrl:'请输入版本下载路径',
        versionSwitch:'请选择版本开关',
        platform:'请选择运行平台',
        forcedUpdate:'请选择是否强制更新',
    }
};

// 费用管理
msgCfg.feeitem = {
    List: {
        searchTxt: '请输入费用代码或费用名称查询'
    },
    Detail: {
        itemName: '请输入费用名称',
        itemCode: '请输入费用代码',
        needFlag: '请选择是否必须',
        effectFlag: '请选择是否生效',
        timeLine: '请选择时效类型',
        itemDesc: '请输入费用说明',
        corpNo:'请选择公司',
    }
};

// 资费包管理 
msgCfg.tariffgroup = {
    List: {
        searchTxt: '请输入资费包名称查询'
    },
    Detail: {
        corpNo:'请选择公司名称',
        groupName: '请输入资费包名称',
        groupProCity: '请选择省市区县',
        groupCity: '请选择省市',
        groupType: '请选择资费包类型',
        autoModelNo: '请选择汽车型号',
        elecMode: '请选择充电方式',
        status: '请选择资费包状态',
        effDate: '请选择生效时间',
        expDate: '请选择失效时间',
        groupDesc: '请输入资费包描述',
        maxAmt: '请输入最大金额上限',
        minAmt: '请输入最小金额下限',
        corpNo: '请选择所属公司',
        noDeductible: '请输入不计免赔金额',
        uniqueUnit: '计费单位不能重复',
        uniqueTariffType: '费用类型不能重复',
        tariffTypeNum: '请填写完整的资费信息',
        tariffNotNull: '请填写资费信息',
        noDeductibleFlg: '请选择是否开启不计免赔',
    }
};
// 客户管理 
msgCfg.cust = {
    List: {
        searchTxt: '请输入客户名称查询'
    },
    Detail: {
        custName: '请输入客户姓名',
        idCard: '请输入身份证号',
        birthday: '请选择出生日期',
        custAddr: '请输入身份证地址',
        mobile: '请输入客户手机号',
        age: '请输入客户年龄',
        sex: '请选择客户性别',
        workType: '请选择客户职业类型',
        riskLevel: '请选择风险等级',
        driveNo: '请输入驾照副页档案编号',
        licenseDate: '请选择客户初次领证时间',
        validLicenseDate: '请选择客户驾驶证有效期',
        driveMode: '请选择客户准驾车型',
        statusCode: '请选择客户状态',
        password:  '请输入密码',
        licenseCard:  '请上传驾驶证照片',
        idCardFace:  '请上传身份证正面照片',
        laissezPasser:  '请上传港澳台通行证正面照片',
        passport:  '请上传护照正面照片',
        idCardInverse:  '请上传身份证反面照片',
        idCardSelfie:  '请上传手持证件照片',
        driveInverse:  '请上传驾驶证副页照片',
        needPrepay: '请选择是否需要分时押金',
        remark: '请输入审核备注',
        corpNo: '请选择所属公司',
        imgType: '请选择上传证件照类型',
        cardNo:'请输入卡号',
        numAndWord:'请按照正确的格式进行输入',
    },
    SendMessage: {
        msgTitle: '请输入消息标题',
        msgContent: '请输入消息内容'
    },
    ResetPwd: {
        password: '请输入密码',
        newPassword: '请再次输入密码'
    },
    ResetMoblie: {
        mobile: '请输入修改的手机号码'
    }
};
// 优惠券管理 
msgCfg.coupon = {
    List:{
        searchTxt:'请输入优惠券名称'
    },
    Detail: {
        corpNo: '请选择所属公司',
        couponName: '请输入优惠券名称',
        couponNum: '请输入发行数量',
        limitTime: '请选择是否限制时间',
        couponType: '请选择优惠券类型',
        discountAmount: '请输入可抵扣金额',
        useAmount: '请输入使用金额限制',
        //maxUseNum: '请输入用户最多领取次数',
        couponStatus: '请选择优惠券状态',
        limitTimeType: '请选择时间限制类型',
        effectDays: '请输入有效期天数',
        discountPercent: '请输入折扣比率',
        
    }
};
msgCfg.custwallet = {
    Change: {
        inExpAmount: '请输入金额',
        //type: '请选择资金类型',
        operateType: '请选择增减类型',
        //invoice: '请选择是否开发票'
    }
};
msgCfg.order = {
    List: {
        searchTxt:'请输入订单编号',
    },
    EditOrder: {
        settleBal: '请输入结算金额',
        rssettleBal:'请输入修改的结算金额'
    },
    OrderLvar:{
        accidentSpot:'请输入事故地点',
        tarName:'请输入事故登记人',
        avdc:'请输入车辆损坏情况',
        tabDescription:'请输入事故行为描述',
    }
};

//客户退费管理
msgCfg.custWalletEarnestWithDraw = {
    List: {
        searchTxt: '请输入客户手机号查询'
    },
    Detail: {
    },
    Agree:{
        setUser:'请输入处理人',
        setDate:'请选择处理时间',
        setEnd:'请选择处理结果',
    },
    verify:{
        setUser:'请输入处理人',
        setMark:'请输入备注',
        setEnd:'请选择处理结果',
    }
};

// 车型管理
msgCfg.automodel = {
    List: {
        searchTxt: '请输入车型名称查询'
    },
    Detail: {
        modelName: '请输入车型名称',
        autoType: '请选择汽车类型',
        imrfc2397: '请选择车型照片',
        autoBrandName: '请输入汽车品牌',
        autoModel: '请选择汽车型号',
        autoSpec: '请选择汽车规格',
        loadNum: '请输入荷载人数',
        loadWeight: '请输入荷载重量',
        manufacturer: '请输入生产厂家',
        autoSeries: '请输入车系',
        modelYear: '请输入年款',
        engineType: '请选择动力类型',
        autoLevel: '请选择级别',
        mileage: '请输入续航里程',
        corpNo: '请选择所属公司',
    }
};

// 车辆管理
msgCfg.auto = {
    List: {
        searchTxt: '请输入车牌号查询'
    },
    Detail: {
        autoTeamName: '请选择车队',
        corpNo: '请选择管理单位',
        rtNo: '请选择初始化停车点',
        autoModelNo: '请选择车型',
        groupNo: '请选择资费包',
        tmnlNo: '请选择设备名称',
        licenseNo: '请输入车牌号',
        vinNo: '请输入车架号',
        engineNo: '请输入发动机号',
        madeDate: '请选择生产日期',
        buyDate: '请选择购置日期',
        autoUse: '请选择车辆用途',
        autoStatus: '请选择车辆运营状态',
        groupId: '请选择资费包',
        maxPQ: '请输入最大电量',
        driveMode: '请选择准驾级别',
        soc: '请输入荷电状态',
        soc_number: '请输入0-1之间的数值',
        batteryNum: '请输入电池包数量',
        autoRentalStatus:'请选择租赁状态',
        licenseNocheck:'请按照正确的车牌号格式输入',
        numAndWord:'请按照正确的格式进行输入',
    }
};

//车辆保险
msgCfg.autoinsurance = {
    List: {
        searchTxt: '请输入车牌号查询'
    },
    Detail: {
        autoNo: '请选择车牌号',
        insManfacName: '请选择保险厂家',
        insTypeName: '请选择保险项目',
        insAmt: '请输入保险金额',
        insNo: '请输入保险单号',
        insEffdate: '请选择生效日期',
        insExpdate: '请选择失效日期'
    }
};

// 车辆电池管理
msgCfg.autobattery = {
    List: {
        searchTxt: '请输入电池编号查询'
    },
    Detail: {
        tmnlMode: '请输入电池编号',
        bmsCode:'请输入设备编码',
    }
};

// 设备状态
msgCfg.tmnlreal = {
    List: {
        searchTxt: '请输入ICCID号查询'
    }
};
// 车辆监控
msgCfg.autocontrol = {
    selCmd: '请选择指令',
    selCreateStart: '请选择开始时间',
    noCarHistory: '该车在此时间段内没有运动轨迹',
    licenseNo: '请输入车牌号',
    correctLicenseNo: '请输入正确的车牌号',
    returnCar:{
        ShutDown:'是否熄火',
        CloseWindow:'是否关窗',
        CloseLight:'是否关灯',
        Charging:'是否充电',
        Key:'钥匙是否弹出',
    },
    callTest:{
        Speed:'速度',
        SOC:'SOC',
        Mileage:'里程',
        DC_StatusStr:'DC状态',
        RunMode:'运行模式',
        TotalCurrent:'总电流',
        InsulationResistance:'绝缘电阻',
        Gear:'挡位',
        ChargedState:'充电状态',
        VehicleStatus:'车辆状态'
    }
};

// 资费管理
msgCfg.tariff = {
    List: {
        searchTxt: '请输入资费名称查询'
    },
    Detail: {
        chargeName:'请输入资费名称',
        ttlVal:'请输入资费(元/度)',
        useState:'请输入系统状态',
        groupNo: '请选择资费包',
        itemCode: '请选择费用代码',
        tariffType: '请选择费用类型',
        unit: '请选择费用单位',
        rateUnit: '请输入计费单元数',
        scaledRateValue: '请输入单位费率',
        fixedRateValue: '请输入固定费率',
        tsFlag: '请选择分时标志',
        itemCodeCheck: '请选择费用名称',
        tariffTypeCheck: '请选择费用类型',
        unitCheck: '请选择计费单位',
        tsFlagCheck: '请选择分时标志',
        feeAmt: '请输入费用',
    }
};

//广告页面
msgCfg.advert ={
    List: {
        searchTxt: '请输入广告名称查询'
    },
    Detail: {
        adName:'请输入广告名称',
        adUrl:'请输入广告地址', 
        imRfc2397:'请上传图片',
        adUrl1:'请输入正确的格式'
    }
}

msgCfg.ledger = {
    List: {
        searchTxt: '请输入用户手机号查询'
    }
}

//商品页面
msgCfg.goods ={
    List: {
        searchTxt: '请输入商品名称查询'
    },
    Detail: {
        goodName:'请输入商品名称',
        goodPrice:'请输入商品单价', 
        imRfc2397:'请上传商品图片',
    }
}
// 站点车辆相关
msgCfg.autorentalrelation = {
    Delete: {
        searchTxt: '请输入车牌号'
    },
    Add: {
        searchTxt: '请输入车牌号'
    }
};

// 站点车辆相关
msgCfg.optorder = {
    List: {
        searchTxt: '请输入运维订单号'
    },
};

// 仪表盘
msgCfg.dashboard = {
    Main: {
        selCorp: '请选择公司',
        selStartDate: '请选择开始日期',
    }
};


// 系统配置
msgCfg.sysconfig = {
    List:{
        searchTxt:'请输入类型名称查询'
    },
    Detail: {
        codeValue: '请输入配置代码',
        codeName: '请输入配置名称',
        codeDisp: '请输入显示顺序',
        codeType:'请输入代码',
        codeTypeName:'请输入代码名称',
        codeName:'请输入名称',
        codeContent1:'请输入内容',
        codeDisp:'请输入排序',
    }
};

// 礼包管理
msgCfg.gift = {
    List:{
        searchTxt:'请输入礼包名称查询'
    },
    Detail:{
        giftName:'请输入礼包名称',
    }
}

// 优惠券管理 
msgCfg.discount = {
    List:{
        searchTxt:'请输入折扣名称'
    },
    Detail: {
        discountName: '请输入折扣名称',
        amtLimit: '请输入使用金额限制',
        custOrgId: '请选择客户所属机构',
        rentalOrgId: '请选择网点所属机构',
        discountVal: '请输入折扣比率',
        useState: '请选择系统状态'
    }
};
//兑换卡
msgCfg.cashcard = {
    List:{
        searchTxt:'请输入折扣名称'
    },
    Detail: {
        cashcardNum: '请输入兑换卡数量',
        cashcardVal: '请选择兑换卡金额',
        custOrgId: '请选择客户所属机构',
        rentalOrgId: '请选择网点所属机构',
        discountVal: '请输入折扣比率',
        useState: '请选择系统状态'
    }
};

// 活动中心 
msgCfg.event2 = {
    List:{
        searchTxt:'请输入活动名称'
    },
    Detail: {
        eventTitle: '请输入标题',
        eventStatus: '请选择活动状态',
        eventLimit: '请选择是否有时间限制',
        imrfc2397:'请上传图片',
    }
};
//经销商
msgCfg.dealer = {
    List:{
        searchTxt:'请输入经销商名称'
    },
    Detail: {
        eventTitle: '请输入经销商名称',
        eventStatus: '请输入地址',
        eventPhone:'请输入电话',
        eventPerson:'请输入联系人',
    }
};
// 充电桩
msgCfg.chargingpile = {
    List:{
        searchTxt:'请输入充电桩编号'
    },
    Detail: {
        eventTitle: '请选择充电桩型号名称',
        eventStatus: '请选择所属经销商',
    }
};
//充电桩型号
msgCfg.piletype = {
    List:{
        searchTxt:'请输入充电桩编号'
    },
    Detail: {
        eventTitle: '请选择充电桩型号名称',
        eventCode:'请输入型号',
        eventCurrent:'请选择电流输出类型',
        eventSpeed:'请选择充电速度',
        eventInter:'请选择接口类型',
        eventGunNum:'请输入充电枪数量',
        eventStatus: '请选择系统状态',
    }
};
// 充电用户
msgCfg.charginguser = {
    List:{
        searchTxt:'请输入手机号码'
    },
    Detail: {
        eventStatus: '请选择所属经销商',
        mobile:'请输入手机号码',
        custName:'请输入姓名',
        birthday:'请输入出生日期',
        sex:'请输入性别',
        dealNo:'请选择经销商',
        password:'请输入密码',
        
    }
};
//
msgCfg.settle = {
    List:{
        searchTxt:'请输入结算策略名称'
    },
    Detail: {
        strategyName: '请输入结算策名称',
        strategyType: '请选择结算周期',
        settleType: '请选择结算方式',
        useState: '请选择使用状态',
        settleVal: '请输入支付支出的金额或者比例',
        
    }
};
// 充电网点
msgCfg.branch = {
    List:{
        searchTxt:'请输入结算策略名称'
    },
    Detail: {
        stationName: '请输入充电网点名称',
        dealNo: '请选择所属经销商',
        stationAddr: '请输入地址',
        city: '请选择区域',
        rtLon: '请填写经度',
        rtLat: '请填写纬度',
        parkRate: '请选择停车费',
        portType: '请选择停车场类型',
        startChargeMode: '请选择充电方式',
    }
};

// 长度校验
msgCfg.max_2 = '长度小于 2 个字符';
msgCfg.max_5 = '长度小于 5 个字符';
msgCfg.max_6 = '长度小于 6 个字符';
msgCfg.max_8 = '长度小于 8 个字符';
msgCfg.max_9 = '长度小于 9个字符';
msgCfg.max_10 = '长度小于 10 个字符';
msgCfg.max_11 = '长度小于 11 个字符';
msgCfg.max_12 = '长度小于 12 个字符';
msgCfg.max_13 = '长度小于 13 个字符';
msgCfg.max_15 = '长度小于 15 个字符';
msgCfg.max_16 = '长度小于 16 个字符';
msgCfg.max_18 = '长度小于 18 个字符';
msgCfg.max_20 = '长度小于 20 个字符';
msgCfg.max_30 = '长度小于 30 个字符';
msgCfg.max_32 = '长度小于 32 个字符';
msgCfg.max_64 = '长度小于 64 个字符';
msgCfg.max_100 = '长度小于 100 个字符';
msgCfg.max_256 = '长度小于 256 个字符';
msgCfg.max_2000 = '长度小于 2000 个字符';
msgCfg.max_1000 = '长度小于 1000 个字符';
msgCfg.min_6 = '长度大于 6 个字符';
//是否确认已经收货
msgCfg.isComfirmRec = '是否确认已经收货?';
//确认收货成功
msgCfg.confirmRecSuc = '确认收货成功';
//输入框校验
msgCfg.inputCheck = '请输入正确的搜索内容';
// 手机号校验
msgCfg.mobile = '手机号格式错误';
// 用户名（手机号+邮箱+....）
msgCfg.loginUser = '用户名格式错误';
//年龄校验
msgCfg.age = '请输入合法的年龄';
//身份证校验
msgCfg.idCard = '请输入合法的身份证号码';
//驾驶证校验
msgCfg.driveNo = '请输入合法的驾驶证号码';
//驾照副页档案编号
msgCfg.driveLicenseNo = '请输入合法的驾照副页档案编号'; 
//邮箱格式校验
msgCfg.email = '邮箱格式错误';
// 接口请求失败
msgCfg.ajaxErr = '系统繁忙，请稍后重试！';
// 操作对象校验
msgCfg.selectOne = '只能选择一个对象操作！';
msgCfg.selectNeed = '请选择需要操作的对象！';
msgCfg.selectNo = '此条信息已被处理！';
//检验输入或选择与否
msgCfg.checkInputVal = '请输入或选择ICCID号！';
// Token超时
msgCfg.tokenTimeout = 'Token超时，请重新登录！';
// 删除
msgCfg.delAsk = '是否确认删除？';
msgCfg.delSuc = '删除成功！';
msgCfg.dealerr = '充电桩型号正在使用，删除失败！';
msgCfg.discounterr = '折扣正在被使用，删除失败!';
// 拒绝
msgCfg.rejAsk = '是否确认拒绝？';
msgCfg.rejSuc - '拒绝成功！';
//发送指令
msgCfg.sendOrder = '是否确认发送指令';
msgCfg.sendOrderSuc = '指令发送成功，完成后系统会有消息提醒';
// 添加
msgCfg.addAsk = '是否确认添加？';
msgCfg.addSuc = '添加成功！';
msgCfg.addCarSuc = '绑定成功！';
// 移除
msgCfg.removeAsk = '是否确认移除？';
msgCfg.removeSuc = '移除成功！';
msgCfg.removeCarSuc = '解绑成功！';
// 强制结束订单
msgCfg.stopOrder = '是否确认强制结束订单？';
msgCfg.stopOrderSuc = '结束订单成功！';
// 修改结算金额
msgCfg.editOrderSuc = '修改结算金额成功！';
// 客户停用
msgCfg.disUse = '是否确认停用？';
msgCfg.disUseSuc = '停用成功！';
msgCfg.disFenceStatusSuc = '修改围栏状态成功！';
//广告页面
msgCfg.advertdisable = '广告页面注销成功';
msgCfg.advertenable = '广告页面启用成功';
//商品管理
msgCfg.uppersuc = '商品上架成功';
msgCfg.downsuc = '商品下架成功';
//普通资费
msgCfg.tariffdisable = '普通资费注销成功';
msgCfg.tariffenable = '普通资费开启成功';
//内部折扣
msgCfg.discountdisable = '内部折扣注销成功';
msgCfg.discountenable = '内部折扣开启成功';
//充电桩型号
msgCfg.disable = '充电桩注销成功';
msgCfg.enable = '充电桩开启成功';
//结束运维订单
msgCfg.disUseOrder = '是否结束运维订单？';
msgCfg.disUseOrderSuc = '结束运维订单成功！';
//车辆控制
msgCfg.unlocking = '是否确认开锁？';
msgCfg.unlockingSuc = '开锁成功！';
msgCfg.shutting = '是否确认闭锁？';
msgCfg.shuttingSuc = '闭锁成功！';
msgCfg.findCar = '是否确认寻车？';
msgCfg.findCarSuc = '寻车成功！';
msgCfg.recallTest = '是否确认召测？';
msgCfg.recallTestSuc = '召测成功！';
msgCfg.giveBack = '是否确认还车？';
msgCfg.giveBackSuc = '还车成功！';
// 违章处理
msgCfg.handle = '是否确认违章处理？';
msgCfg.handleSuc = '违章处理成功！';
// 成功
msgCfg.addSuc = '添加成功！';
msgCfg.importExcelSuc = '导入成功！';
msgCfg.editSuc = '修改成功！';
msgCfg.sendSuc = '发送成功！';
msgCfg.resetSuc = '重置成功！';
msgCfg.saveSuc = '保存成功！';
msgCfg.excel = '导入成功！';
msgCfg.sysError ='程序内部错误，请联系管理员';
msgCfg.checkSuc = '审核修改成功'
//失败
msgCfg.resetErr = '重置失败，请检验两次输入密码是否一致！';
// 时间
msgCfg.startDate = '开始日期';
msgCfg.endDate = '结束日期';
msgCfg.selectDate = '选择日期';
msgCfg.startTime = "开始时间";
msgCfg.endTime = "结束时间"
msgCfg.selectTime = '选择时间';
msgCfg.selectDateInput = '请选择日期';
msgCfg.date = '起始时间应早于结束时间';
msgCfg.dateError = '生效日期应早于失效日期';
msgCfg.dateRegex = '运营开始时间不能晚于运营结束时间';
msgCfg.dateErrorMsg = '生产日期应早于安装日期';
msgCfg.dateErrorMessage = '生效日期应早于失效日期';
msgCfg.dateNotNull = '请选择起始日期';
msgCfg.dateRange = '日期范围不能大于7天';
msgCfg.dateRangeMonth = '日期范围不能大于30天';
msgCfg.autoDateError = '生产日期应早于购置日期';
msgCfg.rentalDateError = '投运日期应早于租约到期日';
msgCfg.openDateError = '运营开始时间应早于结束时间';
msgCfg.licenseError = '初次领证日期应早于驾驶证到期日';
msgCfg.tarTimeError = '事故发生时间应早于事故登记时间';
msgCfg.custInvoiceDateError = '日期';
//客户tab页提醒
msgCfg.checkError = '请确认两页的信息是否填写完善';
//资费已存在
msgCfg.tariffErr = '该资费正在被使用，删除失败！';
msgCfg.advertErr = '该广告页面正在被使用，删除失败！';
msgCfg.tariffMesErr = '信息填写错误';
msgCfg.groupCity = '请选择省市',
msgCfg.groupProvince = '请选择省',
msgCfg.fenceRange = '请在地图上绘制围栏',
//导出提示
msgCfg.exportErr = '请输入设备码再进行导出操作';
//上下限金额比较
msgCfg.money = '上限金额应该大于下限金额';
msgCfg.amount = '可抵扣金额应小于使用金额限制';
//违章状态操作对象校验
msgCfg.lvvrStatusError = '请选择一条处理状态为未处理或者处理中的数据操作！';
msgCfg.orderNoError = '请选择含订单编号的数据进行操作！';
// 数值校验
msgCfg.intVal = '请输入整数';
msgCfg.intHundred = '请输入1-99的整数';
msgCfg.alphabet = '请输入1-32位的大小写字母和数字的组合';
msgCfg.number ='请输入20位的纯数字';
msgCfg.numberDecimal = '请输入最多不超过6位的正确的数值(小数点后最多两位数字)';
msgCfg.decimal = "请输入正确的数字(保留三位小数)";
msgCfg.password = '请输入6-16位必须同时含有大小写字母以及数字的密码格式';
// 数值校验
msgCfg.mathVal = '请输入正确的数值';
msgCfg.assetNoVal = '请输入小于五位的整数作为电池序号';
msgCfg.mathValCard = '请输入正确的证件号格式';
// 订单强制结束校验
msgCfg.selectOneStop = '只能强制结束已下单或租赁中的订单！';
//订单结算金额修改
msgCfg.selectOneEdit = '只能修改待支付状态的订单！';
msgCfg.select = '请选择';
//结束运维订单只能结束运维中的数据
msgCfg.selectOrderStatus = '只能结束运维中的订单！';
export default msgCfg;